import {useEffect, useRef, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "react-bootstrap/Modal";

import customTranslation from "core/customTranslation";
import DropdownDateRange from "components/datetime/DropdownDateRange";
import DateUtils from "core/utils/DateUtils";
import axiApi from "ApiCaller";
import TopBarPaginationFixed from "components/paginator/TopBarPaginationFixed";
import {PagerModel} from "components/paginator/PaginationModel";
import LoaderSpinner from "context/LoaderSpinner";
import ImageModal from "components/ImageModal";
import ConditionalRender from "components/ConditionalRender";
import {MomentUtils} from "core/utils/MomentUtils";

const translate = {
    es: {
        island: "Isla",
        nodata: "No se encuentran imágenes en el rango solicitado",
    },
    en: {
        island: "Island",
        nodata: "No images found in the requested range",
    },
};

const ModalIslandImages = ({show, setShow, island}) => {
    const {t: _TC} = customTranslation(translate);
    const {formatDate, timezone} = MomentUtils();
    const item = island;
    const [items, setItems] = useState([]);
    const [image, setImage] = useState({image: null, dated: null});
    const [loader, setLoader] = useState(false);
    const dateRangeRef = useRef({startDate: new Date(), endDate: new Date()});
    const pagerModelRef = useRef(new PagerModel());
    const [showPrevImage, setShowPrevImage] = useState(false);

    useEffect(() => {
        pagerModelRef.current.paging.size = 12;
        pagerModelRef.current.handleCallApi = () => applyFilter();
        fetchGetItems();
    }, []);

    const fetchGetItems = async () => {
        setLoader(true);
        const params = {id_isla: item.id};

        const resp = await axiApi.get("/api/distribution/image-gallery/", {params});
        pagerModelRef.current.active = false;
        setItems(resp?.data?.items || []);
        setLoader(false);
    };

    const applyFilter = async () => {
        setLoader(true);
        const params = {id_isla: item.id};
        params.start = DateUtils.dateToStringInput(dateRangeRef.current.startDate);
        params.end = DateUtils.dateToStringInput(dateRangeRef.current.endDate);
        const resp = await axiApi.post("/api/distribution/image-gallery/", params, {
            params: pagerModelRef.current.paging.getParams(),
        });
        pagerModelRef.current.active = resp?.data?.items.length > 0;
        pagerModelRef.current.paging.setPager(resp.data);
        setItems(resp?.data?.items || []);
        setLoader(false);
    };

    const handleClose = () => {
        setShow(false);
    };

    const handleDateRangeChange = (newDateRange) => {
        dateRangeRef.current = newDateRange;
        applyFilter();
    };
    const handleImageClick = (item) => {
        setImage(item);
        setShowPrevImage(true);
    };

    return (
        <Modal show={show} onHide={() => setShow(false)} animation={true} size="xl" scrollable={true}>
            <Modal.Header closeButton className="preview-canvas mb-0 aling-items">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="boxes-stacked" />
                </div>
                <div className="d-inline-flex align-items-center">
                    <Modal.Title className="d-inline-flex ms-3">
                        <div>
                            <div>{_TC("island")}</div>
                            <div className="h5">
                                <small>{item.name}</small>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className="d-inline-flex ms-3" role="search">
                        <DropdownDateRange
                            size="sm"
                            dateRange={dateRangeRef.current}
                            setDateRange={handleDateRangeChange}
                            maxDays={7}
                            range={0}
                        />
                    </div>
                    <div className="d-inline-flex ms-3">
                        <TopBarPaginationFixed pagerModel={pagerModelRef.current} size={12} />
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body className="bg-light" style={{minHeight: "400px"}}>
                <div className="container-fluid">
                    <div className="row">
                        <LoaderSpinner isLoading={loader}>
                            {items.length === 0 && (
                                <div className="col-12">
                                    <div className="alert alert-secondary text-center" role="alert">
                                        {_TC("nodata")}
                                    </div>
                                </div>
                            )}
                            {items.map((item, idx) => (
                                <div className="col-md-3 p-2" key={idx}>
                                    <div className="image-card">
                                        <img
                                            src={item.src}
                                            className="img-fluid"
                                            alt="captura"
                                            style={{cursor: "pointer"}}
                                            data-idx={idx}
                                            onClick={() => handleImageClick(item)}
                                        />
                                        <div className="text-center bg-secondary text-light">
                                            {formatDate(item.dated, "DD-MM-YYYY HH:mm") + " - " + item.camera}
                                        </div>
                                    </div>
                                </div>
                            ))}
                            <ConditionalRender condition={showPrevImage}>
                                <ImageModal
                                    show={showPrevImage}
                                    onHide={() => setShowPrevImage(false)}
                                    imageSrc={image.src}
                                    imageAlt={formatDate(image.dated, "DD-MM-YYYY HH:mm")}
                                    camera={image.camera}
                                />
                            </ConditionalRender>
                        </LoaderSpinner>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalIslandImages;
